export default {"src":"/_next/static/image/src/images/about-price.75c973369f5716d58709625b548c769b.svg","height":40,"width":48};